// extracted by mini-css-extract-plugin
export default {"travelContainer":"travel_travelContainer__cZ1Lm","line":"travel_line__IKe7v","line1":"travel_line1__gLb4w","h1":"travel_h1__hrhVE"};